import { put, call, takeLatest } from "redux-saga/effects";

import { login$ } from "../actions/login";

import { login } from "../../services/requestors/login";
import { hist } from "../..";
import { setData } from "../../utils/util";
import toastr from "toastr";

function* handleLogin(action) {
  try {
    yield put(login$.request());

    const { data } = yield call(login, action.payload);
    if (data && data.data && data.data.token) {
      setData("adminData", {
        authToken: data.data.token,
        assignRoles: ["Manage Users"]
      });
      localStorage.setItem("name", data.data.name);
      localStorage.setItem("email", data.data.email);
      localStorage.setItem("id", data.data.id);
      hist.push("/admin/manageevents");
    }
    yield put(login$.success(data.data));
  } catch (error) {
    toastr.error("Incorrect Credentials!");
    yield put(login$.failure(error));
  } finally {
    yield put(login$.fulfill());
  }
}

export default function* loginWatcher() {
  yield takeLatest(login$.TRIGGER, handleLogin);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/login.js